export const convertUrlToFile = url => {
    var blobBin = atob(url.split(",")[1]);
    var array = [];
    for (var i = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
    }
    var blob = new Blob([new Uint8Array(array)], { type: "image/png" });
    return new File([blob], "profile.png", { type: "image/png" });
};
